export default __webpack_public_path__ + "assets/img/Edit.02d21e3c.svg";